import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import ky from 'ky';

function getWindowDimensions() {
  if (typeof window !== 'undefined') {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  return {
    width: 0,
    height: 0,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

function Lives({ ip, size }) {
  return null;

  // eslint-disable-next-line
  const { width } = useWindowDimensions();

  let limit = 2;
  if (size) {
    limit = size;
  } else if (width >= 992) {
    limit = 4;
  } else if (width >= 768) {
    limit = 3;
  }

  try {
    const data = ky
      .get(
        `https://chaturbate.com/api/public/affiliates/onlinerooms/?wm=7u7sN&client_ip=${ip}&limit=4&gender=f`,
      )
      .json();

    return (
      <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4">
        {data.results.slice(0, limit).map((item) => (
          <div key={item.username} className="col mb-4">
            <Link href={item.chat_room_url}>
              <a title={item.room_subject} target="_blank" rel="noopener noreferrer nofollow">
                <div className="live-item-cover overflow-hidden rounded-sm">
                  <Image
                    layout="responsive"
                    src={item.image_url_360x270}
                    alt={item.room_subject}
                    className="card-img-top"
                    width={360}
                    height={270}
                    unoptimized
                  />

                  <span className="live-item-badge d-flex align-items-center justify-content-center rounded-sm">
                    <span className="live-icon-dot" />
                    <span>LIVE</span>
                  </span>

                  <span className="live-item-user d-flex align-items-center">
                    <span className="mr-1">{item.username}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#ff37d1"
                      className="bi bi-gender-female"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5z"
                      />
                    </svg>
                  </span>
                </div>
              </a>
            </Link>
          </div>
        ))}
      </div>
    );
  } catch (e) {
    return (
      <iframe
        title="chaturbate shows"
        src="https://chaturbate.com/in/?track=default&tour=x1Rd&campaign=7u7sN&c=6&p=0&gender=f"
        frameBorder="0"
        className="w-100"
        style={{ height: '390px' }}
      />
    );
  }

  // eslint-enable
}

export default Lives;
